import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=6e68c8c7&scoped=true&"
import script from "./NoticeDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&id=6e68c8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68c8c7",
  null
  
)

export default component.exports